import { render, staticRenderFns } from "./Departures.vue?vue&type=template&id=240f86a0&scoped=true&lang=pug"
import script from "./Departures.vue?vue&type=script&lang=js"
export * from "./Departures.vue?vue&type=script&lang=js"
import style0 from "./Departures.vue?vue&type=style&index=0&id=240f86a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240f86a0",
  null
  
)

export default component.exports